/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

/**
 * Extracts the "userId" value part of an LDAP DN.
 * @param {string} userDn a full LDAP DN for a user
 * @returns {string} the username
 * @example
 *
 * getUserIdFromDn('cn=jdoe0,cn=organizational users,o=dobs,cn=cordys,cn=dev,o=PA.LCL')
 * ->  'jdoe0'
 */
export default function getUserIdFromDn(userDn) {
  if (userDn && _.isString(userDn)) {
    return userDn.substr(0, userDn.indexOf(',')).substr(3);
  } else {
    return undefined;
  }
}
